<template>
  <div class="tab-text">
    <div class="cstm_vuexy_table">
      <table class="course-table course_type_table default_cursor w-full p-4">
        <tr>
          <th style="width: 200px;">
            Chat with participant
          </th>
          <td colspan="2">
            <vs-checkbox v-model="can_chat" :disabled="is_disabled" />
          </td>
        </tr>
      </table>
    </div>

    <div v-if="edit_permission()" class="flex flex-1 justify-end mt-10">
      <vs-button @click="saveChatSettings">Save Settings</vs-button>
    </div>
  </div>
</template>

<script>
import { saveChatSettings } from '@/api/classes'

export default {
  name: 'ChatSettings',
  props: ['chat_settings', 'class_id', 'edit_permission'],
  computed: {
    is_disabled () {
      return !this.edit_permission()
    }
  },
  data () {
    return {
      customer_id: localStorage.getItem('customer_id'),
      can_chat: this.chat_settings
    }
  },
  methods: {
    async saveChatSettings () {
      const payload = {
        customer_id: this.customer_id,
        class_id: this.class_id,
        can_chat: this.can_chat
      }

      try {
        const response = await saveChatSettings(payload)

        if (response.status === 202) {
          this.$emit('on_chat_setting_updated', this.can_chat)
          this.showSuccessMessage('Success', 'Chat settings saved successfully', 'success')
        }
      } catch (e) {
        console.log(e)
        this.showSuccessMessage('Error', e.data.message, 'danger')
        this.can_chat = !this.can_chat
      }
    }
  }
}
</script>
